<div class="agents-container" snAssistantSurface="agentList" surfaceTitle="Agents">
  <!-- Header -->
  <div class="agents-header">
    <div class="title-section">
      <h1 i18n="@@agents.title">Agents</h1>
      <p class="subtitle" i18n="@@agents.subtitle">Create and manage your AI agents</p>
    </div>
    <div class="actions-section">
      <p-button
        i18n-label="@@agents.new"
        label="New agent"
        icon="pi pi-plus"
        (click)="createNewAgent()">
      </p-button>
    </div>
  </div>

  <!-- Search -->
  <div class="search-section">
    <div class="search-input-wrapper">
      <i class="pi pi-search search-icon"></i>
      <input
        pInputText
        type="text"
        i18n-placeholder="@@agents.search"
        placeholder="Search agents..."
        [(ngModel)]="searchTerm"
        snAssistantSkip
        (input)="onSearch()"
        class="search-input">
    </div>
  </div>

  <!-- Table -->
  <div class="table-section">
    <p-table
      [value]="filteredAgents()"
      [loading]="loading()"
      styleClass="agents-table">

      <ng-template pTemplate="header">
        <tr>
          <th i18n="@@agents.col.name">Name</th>
          <th i18n="@@agents.col.createdBy">Created by</th>
          <th>
            <span i18n="@@agents.col.createdAt">Created at</span>
            <i class="pi pi-sort-amount-down"></i>
          </th>
          <th></th>
          <th></th>
        </tr>
      </ng-template>
      
      <ng-template pTemplate="body" let-agent>
        <tr class="clickable-row" [class.pulse-glow-row]="agent.is_created_from_default" (click)="editAgent(agent)">
          <td>
            <div class="agent-name">{{ agent.title }}</div>
          </td>
          <td>
            <div class="agent-owner">{{ agent.created_by_email }}</div>
          </td>
          <td>
            <div class="agent-date">{{ formatDate(agent.created_at) }}</div>
          </td>
          <td class="talk-cell" (click)="$event.stopPropagation()">
            <a [routerLink]="['/agents', agent.id]" fragment="talk" class="talk-button-desktop">
              <p-button
                i18n-label="@@agents.talk"
                label="Talk To Agent"
                icon="pi pi-play"
                size="small">
              </p-button>
            </a>
            <a [routerLink]="['/agents', agent.id]" fragment="talk" class="talk-button-mobile">
              <p-button
                icon="pi pi-play"
                size="small"
                i18n-pTooltip="@@agents.talk"
                pTooltip="Talk To Agent"
                tooltipPosition="top"
                i18n-ariaLabel="@@agents.talk"
                ariaLabel="Talk To Agent">
              </p-button>
            </a>
          </td>
          <td class="actions-cell">
            <!-- Desktop: три отдельные кнопки-иконки с tooltip'ами. -->
            <div class="actions-desktop">
              <a [routerLink]="['/agents', agent.id]" (click)="$event.stopPropagation()">
                <p-button
                  icon="pi pi-pencil"
                  [text]="true"
                  severity="secondary"
                  size="small"
                  [pTooltip]="editActionLabel"
                  tooltipPosition="top"
                  [ariaLabel]="editActionLabel">
                </p-button>
              </a>
              <p-button
                icon="pi pi-copy"
                [text]="true"
                severity="secondary"
                size="small"
                [pTooltip]="duplicateActionLabel"
                tooltipPosition="top"
                (click)="duplicateAgent(agent, $event)"
                [snAssistantAction]="'duplicate.' + agent.id"
                [actionLabel]="'Duplicate ' + agent.title"
                actionHint="Opens the duplicate page pre-filled from this agent — a copy to try risky changes on."
                [ariaLabel]="duplicateActionLabel">
              </p-button>
              <p-button
                icon="pi pi-trash"
                [text]="true"
                severity="danger"
                size="small"
                [pTooltip]="deleteActionLabel"
                tooltipPosition="top"
                (click)="deleteAgent(agent, $event)"
                [snAssistantAction]="'delete.' + agent.id"
                [actionLabel]="'Delete ' + agent.title"
                actionDangerous
                actionHint="Deletes the agent. Numbers pointing at it stop answering and campaigns using it stop calling."
                [ariaLabel]="deleteActionLabel">
              </p-button>
            </div>
            <!-- Mobile: одна кнопка ellipsis + p-menu со всеми действиями
                 и явными текстовыми labels (без tooltip'ов, экран узкий). -->
            <div class="actions-mobile">
              <p-button
                icon="pi pi-ellipsis-h"
                [text]="true"
                severity="secondary"
                size="small"
                [pTooltip]="moreActionsLabel"
                tooltipPosition="top"
                (click)="rowMenu.toggle($event); $event.stopPropagation()"
                [ariaLabel]="moreActionsLabel">
              </p-button>
              <p-menu
                #rowMenu
                [model]="menuItemsFor(agent)"
                [popup]="true"
                [appendTo]="'body'">
              </p-menu>
            </div>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="5" class="empty-message" i18n="@@agents.empty">
            No agents found
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>

  <!-- Delete Confirmation Dialog -->
  <app-delete-confirmation
    [(visible)]="showDeleteDialog"
    [title]="deleteTitle"
    [subtitle]="deleteSubtitle"
    [deleting]="isDeleting()"
    (confirm)="onDeleteConfirm()">
  </app-delete-confirmation>

  <!-- Duplicate Confirmation (через ConfirmationService.confirm() из
       duplicateAgent) — рисуется этим диалогом. -->
  <p-confirmDialog [style]="{ width: '450px' }"></p-confirmDialog>

  <!-- Mobile Bottom Bar -->
  <div class="mobile-bottom-bar">
    <div class="mobile-bottom-actions">
      <p-button
        i18n-label="@@agents.new"
        label="New agent"
        icon="pi pi-plus"
        (click)="createNewAgent()">
      </p-button>
    </div>
  </div>
</div>
